<template>
  <div class="config-container">
    <div class="header">
      <h2>请求值=1 自定义项配置</h2>
      <button @click="handleLogout">退出登录</button>
    </div>
    <div class="add-item">
      <input v-model="newItem" type="text" placeholder="输入自定义项内容">
      <button @click="addItem">添加</button>
    </div>
    <div class="item-list">
      <div class="item" v-for="(item, index) in itemList" :key="index">
        <span>{{ item.content }}</span>
        <button @click="deleteItem(index)">删除</button>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/api/request';

export default {
  name: 'Config',
  data() {
    return {
      newItem: '',
      itemList: []
    };
  },
  mounted() {
    this.getItems(); // 页面加载时获取所有自定义项
  },
  methods: {
    async getItems() {
      try {
        const res = await request.get('/items');
        this.itemList = res.data;
      } catch (err) {
        console.error(err);
      }
    },
    async addItem() {
      if (!this.newItem.trim()) {
        alert('请输入内容');
        return;
      }
      try {
        await request.post('/items', {
          content: this.newItem,
          requestValue: 1
        });
        this.newItem = '';
        this.getItems(); // 重新刷新列表
      } catch (err) {
        console.error(err);
      }
    },
    async deleteItem(index) {
      const item = this.itemList[index];
      try {
        await request.delete(`/items/${item.id}`);
        this.getItems(); // 重新刷新列表
      } catch (err) {
        console.error(err);
      }
    },
    handleLogout() {
      localStorage.removeItem('token');
      this.$router.push('/'); // 退出跳转到登录页
    }
  }
};
</script>

<style scoped>
.config-container {
  width: 80%;
  margin: 0 auto;
  padding: 20px;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.header button {
  padding: 8px 16px;
  border: none;
  background: #ff4444;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
}
.add-item {
  display: flex;
  margin-bottom: 30px;
}
.add-item input {
  flex: 1;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px 0 0 4px;
}
.add-item button {
  padding: 0 20px;
  border: none;
  background: #42b983;
  color: #fff;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
}
.item-list {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}
.item {
  display: flex;
  align-items: center;
  background: #f5f5f5;
  padding: 10px 15px;
  border-radius: 4px;
}
.item span {
  margin-right: 10px;
}
.item button {
  padding: 4px 8px;
  border: none;
  background: #ff4444;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}
</style>